module.exports = __webpack_public_path__ + "img/PROBIOTICOS.0154a9c0.png";